import { useState } from "react"
import OneModal from "../OneModal/OneModal"
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import VideoCam from "./VideoCam"

const WebCam = ({ open, setOpen, retornoFunc, semMask = false, cropActive = false }) => {
    const [loadingModal] = useState(false)

    return (
        <>
            <OneModal
                open={open}
                setOpen={setOpen}
                titleText={'Capturar Imagem'}
                loading={loadingModal}
                fullWidth='true'
            >
                <Grid container xs={12}>
                    <VideoCam close={open} setClose={setOpen} retornoFunc={retornoFunc} semMask={semMask} cropActive={cropActive}/>
                </Grid>
            </OneModal>
        </>
    )
}

export default WebCam
